module.exports = __webpack_public_path__ + "img/e-mail.6ccf5422.png";